module.exports = __webpack_public_path__ + "static/media/standard_black.15d4adcc.svg";